export enum ProductOptions {
    BillAsPackage = 'BillAsPackage',
    CreateTask = 'CreateTask',
    ExcludePriceFromOffer = 'ExcludePriceFromOffer',
    None = 'None',
    OfferToCustomer = 'OfferToCustomer',
    OfferToEmployee = 'OfferToEmployee',
    SelectedByDefault = 'SelectedByDefault',
}
